import { map } from 'rxjs/operators';
import { parseDate } from '../utils/date-utils';
import { BaseService } from './base-service';
export class CompanyInvoiceService {
    // ----------------------------------------------------------------------
    // Invoices
    // ----------------------------------------------------------------------
    static getCompanyInvoicesDashboard(companyId) {
        return BaseService.get(`company-invoice-dashboard/${companyId}`)
            .pipe(map(w => {
            return w;
        }));
    }
    static getCompanyInvoices(companyId, filter, pageNumber) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        //return BaseService.getPaginated<ICompanyDTO[]>(`companies?filter=${qs}`, pageNumber)
        return BaseService.getPaginated(`company-invoices/${companyId}?filter=${qs}`, pageNumber)
            .pipe(map(w => {
            w.payload.forEach(x => {
                x.invoice.createdOn = parseDate(x.invoice.createdOn);
                x.invoice.updatedOn = parseDate(x.invoice.updatedOn);
                x.invoice.dataEmissione = parseDate(x.invoice.dataEmissione);
                x.invoice.dataPagamento = x.invoice.dataPagamento == null ? null : parseDate(x.invoice.dataPagamento);
                x.invoice.dataScadenza = x.invoice.dataScadenza == null ? null : parseDate(x.invoice.dataScadenza);
            });
            return w;
        }));
    }
    static downloadInvoicePDF(oid) {
        BaseService.downloadFile(`company-invoice-pdf/${oid}`, 'fattura.pdf', null);
    }
    static getCompanyInvoicesEmails(filter, pageNumber) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        //return BaseService.getPaginated<ICompanyDTO[]>(`companies?filter=${qs}`, pageNumber)
        return BaseService.getPaginated(`company-invoices-emails/?filter=${qs}`, pageNumber)
            .pipe(map(w => {
            w.payload.forEach(x => {
                x.email.createdOn = parseDate(x.email.createdOn);
                x.invoice.createdOn = parseDate(x.invoice.createdOn);
                x.invoice.updatedOn = parseDate(x.invoice.updatedOn);
                x.invoice.dataEmissione = parseDate(x.invoice.dataEmissione);
                x.invoice.dataPagamento = x.invoice.dataPagamento == null ? null : parseDate(x.invoice.dataPagamento);
                x.invoice.dataScadenza = x.invoice.dataScadenza == null ? null : parseDate(x.invoice.dataScadenza);
            });
            return w;
        }));
    }
    static getCompanyInvoicePayments(filter, updatedata) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        let updatedataqs = "&updatedata=" + updatedata;
        return BaseService.get(`company-invoice-payments/?filter=${qs}` + updatedataqs)
            .pipe(map(w => {
            w.payload.forEach(x => {
                x.invoice.createdOn = parseDate(x.invoice.createdOn);
                x.invoice.updatedOn = parseDate(x.invoice.updatedOn);
                x.invoice.dataEmissione = parseDate(x.invoice.dataEmissione);
                x.invoice.dataPagamento = x.invoice.dataPagamento == null ? null : parseDate(x.invoice.dataPagamento);
                x.invoice.dataScadenza = x.invoice.dataScadenza == null ? null : parseDate(x.invoice.dataScadenza);
                x.payment.createdOn = parseDate(x.payment.createdOn);
                x.payment.updatedOn = parseDate(x.payment.updatedOn);
                x.payment.dataPagamento = x.payment.dataPagamento == null ? null : parseDate(x.payment.dataPagamento);
                x.payment.dataScadenza = x.payment.dataScadenza == null ? null : parseDate(x.payment.dataScadenza);
            });
            return w;
        }));
    }
    static deleteCompanyInvoicePayment(paymentId) {
        return BaseService.save(`company-invoice-delete-by-payment/${paymentId}`, null);
    }
    static getCompanyInvoicePaymentsEmails(filter, pageNumber) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        //return BaseService.getPaginated<ICompanyDTO[]>(`companies?filter=${qs}`, pageNumber)
        return BaseService.getPaginated(`company-invoice-payment-emails/?filter=${qs}`, pageNumber)
            .pipe(map(w => {
            w.payload.forEach(x => {
                x.email.createdOn = parseDate(x.email.createdOn);
            });
            return w;
        }));
    }
    static saveCompanyInvoicePayment(dto) {
        return BaseService.save(`company-invoice-payment`, dto);
    }
    static sendCompanyInvoicePaymentEmails(pec, targets, cloneOfOid) {
        var ids_dto = {
            targets: targets,
            pec: pec,
            cloneOfOid: cloneOfOid
        };
        return BaseService.save(`company-invoice-payment-emails`, ids_dto);
    }
    static sendCompanyInvoiceEmail(oid) {
        return BaseService.save(`company-invoices-emails/${oid}`, oid);
    }
    static saveCompanyInvoice(dto) {
        return BaseService.save(`company-invoice`, dto);
    }
    static deleteCompanyInvoice(oid) {
        return BaseService.delete(`company-invoice/${oid}`);
    }
    // ----------------------------------------------------------------------
    // Search Dropdown
    // ----------------------------------------------------------------------
    static searchReferentiCombo(selfId, search) {
        let qs = encodeURIComponent(search);
        return BaseService.get(`company-invoice-payment-referenti-combo/${selfId}?search=${qs}`);
    }
}
